import { render, staticRenderFns } from "./ContabilizarIcon.vue?vue&type=template&id=4d3e05b1&scoped=true"
var script = {}
import style0 from "./ContabilizarIcon.vue?vue&type=style&index=0&id=4d3e05b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3e05b1",
  null
  
)

export default component.exports